export  const buildFetchUrlPath=(fetchModel,sliceState)=> `${fetchModel}/estados-de-cuenta/?showAll=${sliceState.displayAll}`